// Flujos de almacenaje (put away)

// Lista de flujos de putaway
export const putawayFlows = [
  {
    key: 'putaway-pieza',
    label: 'Put Away Pieza por Pieza',
    description: 'Coloca productos pieza por pieza desde staging a ubicación destino.'
  },
  {
    key: 'putaway-hu',
    label: 'Put Away por Pallet (HU)',
    description: 'Coloca pallets completos (HU) desde staging a ubicación destino.'
  }
];

// Esquemas detallados para el wizard de putaway
export const putawayFlowSchemas = {
  'putaway-pieza': {
    name: 'Put Away Pieza por Pieza',
    steps: [
      { type: 'scan', label: 'Escanea área de staging', field: 'staging-putaway', placeholder: 'Escanea o ingresa el área de staging', validation: { required: true } },
      { type: 'scan', label: 'Escanea el SKU', field: 'scansku-putaway', placeholder: 'Escanea o ingresa el SKU', validation: { required: true } },
      { type: 'scan', label: 'Escanea ubicación destino', field: 'scanubicacion-putaway', placeholder: 'Escanea o ingresa la ubicación destino', validation: { required: true } },
      { type: 'confirm-putaway', label: 'Confirmar putaway' }
    ]
  },
  'putaway-hu': {
    name: 'Put Away por Pallet (HU)',
    steps: [
      { type: 'scan', label: 'Escanea área de staging', field: 'staging-putaway', placeholder: 'Escanea o ingresa el área de staging', validation: { required: true } },
      { type: 'scan', label: 'Escanea el código de pallet (HU)', field: 'scanhu-putaway', placeholder: 'Escanea o ingresa el código de HU', validation: { required: true } },
      { type: 'scan', label: 'Escanea ubicación destino', field: 'scanubicacion-putaway', placeholder: 'Escanea o ingresa la ubicación destino', validation: { required: true } },
      { type: 'confirm-putaway', label: 'Confirmar putaway' }
    ]
  }
};
